import strFunc from "@/lib/lyg/string";

class SupplyListFunc{
  static get_ordered_supply_info_arr(inData:any){
    let opt_obj={
      infoArr:[],
      ...inData
    };
    let change_infoArr:any=[];
    let pay_info_arr=[];
    //납부완료는 밑으로보낸다.
    for(let i=0;i<opt_obj.infoArr.length;i++){
      let info=opt_obj.infoArr[i];
      if(!strFunc.is_empty(info["a_pay_money"])&&info["a_pay_money"]==info["a_money_sum"]){
        pay_info_arr.push(info);
      }else{
        change_infoArr.push(info);
      }
    }
    let infoArr=[
      ...change_infoArr,
      ...pay_info_arr
    ];
    return infoArr;
  }
};
export default SupplyListFunc;